import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from 'react-router-dom';

// UI
import MainLoader from '../../../components/Loaders/MainLoader';
import HomeLayout from '../../../layouts/HomeLayout';
import CardContract from '../../../components/cards/CardContract';
import CardForms from '../../../components/cards/CardForms';
import CardDocs from '../../../components/cards/CardDocs';
import BreadTwoParts from '../../../components/breadcrumbs/BreadTwoParts';
import { Toast } from '../../../resources/utils';
import { TrashIcon } from 'lucide-react';
import CardPrivacePolicy from '../../../components/cards/CardPrivacePolicy';
import CardPlace from '../../../components/cards/CardPlace';

// SLICE
import { getAllProcesByStudentThunk, getAllProcesMatriculationThunk, initialState } from '../../../store/slices/public/procesoMatriculacion.slice';
import { getStudentThunk } from '../../../store/slices/catalogs/students.slice';
import { getConfigsThunk } from '../../../store/slices/catalogs/config.slice';
import { formatMonthYear } from '../../../utils/funtions';

const StudentProgress = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { student_id } = useParams();
    const [dataContrat, setDataContract] = useState({});
    const { items, message, error } = useSelector(state => state.proceso_matriculacion);
    const { item } = useSelector(state => state.students);
    const isLoading = useSelector(state => state.isLoadingSlice);
    const configuration = useSelector(state => state.configurations);
    const today = new Date().toLocaleDateString('es-EC');

    useEffect(() => {
        dispatch(getAllProcesByStudentThunk(student_id));
        dispatch(getStudentThunk(student_id));
        dispatch(getConfigsThunk());
        return () => {
            dispatch(initialState())
        }
    }, [student_id]);

    useEffect(() => {
        if (item.parents) {
            const result = item.parents.find(parent => parent.idReservacionCupo)
            setDataContract({
                today: today,
                nombre_representante: result && result.parent?.nombre + ' ' + result.parent?.apellido,
                cedula_representante: result && result.parent?.ci_padre || 'Sin asignar',
                correo_representante: result && result.parent?.email || 'Sin asignar',
                celular_representante: result && result.parent?.celular || 'Sin asignar',
                direccion_representante: result && result.parent?.direccion || 'Sin asignar',
                nombre_estudiante: item.nombre + ' ' + item.apellido,
                curso_seccion: item.course?.name,
                rector_colegio: configuration.items[0]?.director,
                nombre_colegio: configuration.items[0]?.name,
                RUC: configuration.items[0]?.phone,
                siguiente_periodo: formatMonthYear(configuration.items[0]?.fecha_inicio_periodo_siguiente) + ' - ' + formatMonthYear(configuration.items[0]?.fecha_fin_periodo_siguiente),
            })
        }
    }, [item, configuration]);

    useEffect(() => {
        if (message) {
            Toast.fire({
                icon: 'success',
                title: message,
            });
            dispatch(getAllProcesByStudentThunk(student_id));
        }
    }, [message]);

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className='mx-5 my-5 w-full overflow-y-auto'>

                    <BreadTwoParts
                        titleOne={t("Estudiantes")} toOne={"/panel/students"}
                        titleTwo={"Proceso de Matriculación" + ' > ' + item.nombre + ' ' + item.apellido} />

                    <div className='flex flex-col gap-2'>
                        <CardPrivacePolicy title="Aceptacion politicas de privacidad" item={items?.privacePolicy || {}} />
                        <CardPlace title="Reservacion de cupo" item={items?.place || {}} />
                        <CardContract title="Contratos" datosContrato={dataContrat} items={items?.contracts || []} />
                        <CardDocs title="Documentos" items={items?.documents || []} />
                        <CardForms title="Formularios" datos={dataContrat} items={items?.forms || []} />
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default StudentProgress;
